export default __webpack_public_path__ + "static/media/Resume.17244063.png";